import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import Swal from "sweetalert2"

const { Container, Row, Col, Card } = require("react-bootstrap")

const OcrNext = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { data } = location.state || {}

  const readSummary = () => {
    Swal.fire({
      icon: 'info',
      title: data.content.summary,
    })
    const synth = window.speechSynthesis
    synth.cancel()
    const utterance = new SpeechSynthesisUtterance(data.content.summary)
    utterance.lang = 'fr-FR'
    synth.speak(utterance)
  }

  const readDetails = () => {
    Swal.fire({
      icon: 'info',
      text: data.content.details,
    })
    const synth = window.speechSynthesis
    synth.cancel()
    const utterance = new SpeechSynthesisUtterance(data.content.details)
    utterance.lang = 'fr-FR'
    synth.speak(utterance)
  }

  const aksQuestion = () => {

  }

  const readTasks = () => {
    Swal.fire({
      icon: 'info',
      html: data.content.actions.join("<br /><br />"),
    })
    const synth = window.speechSynthesis
    synth.cancel()
    const utterance = new SpeechSynthesisUtterance(data.content.actions.join("\n"))
    utterance.lang = 'fr-FR'
    synth.speak(utterance)
  }

  const backHome = () => {
    const synth = window.speechSynthesis
    synth.cancel()
    navigate('/')
  }

  const showResume = () => {
    Swal.fire({
      icon: 'info',
      title: data.content.summary,
      text: data.content.details,
    })
  }

  useEffect(() => {
    console.log(data)
    if (data?.content?.summary) {
      readSummary()
    }
  }, [data])

  return (
    <Container>
      <Row className="justify-content-md-center text-center">
        <Col lg={4}>
          <Card className="my-3" style={{ borderRadius: '20px'}} onClick={readSummary}>
            <Card.Body style={{ backgroundColor: '#0E3386', color: 'white', borderRadius: '20px' }}>
              <h1>
                <i className="bi bi-fonts" style={{ fontSize: '2em' }}></i>
              </h1>
              <h3>
                Récouter le résumé
              </h3>
            </Card.Body>
          </Card>
          <Card className="mb-3" style={{ borderRadius: '20px'}} onClick={readDetails}>
            <Card.Body style={{ backgroundColor: '#006400', color: 'white', borderRadius: '20px' }}>
              <h1>
                <i className="bi bi-layout-text-sidebar-reverse" style={{ fontSize: '2em' }}></i>
              </h1>
              <h3>
                Écouter les détails
              </h3>
            </Card.Body>
          </Card>
          <Card className="mb-3" style={{ borderRadius: '20px'}} onClick={readTasks}>
            <Card.Body style={{ backgroundColor: '#CD5700', color: 'white', borderRadius: '20px' }}>
              <h1>
                <i className="bi bi-list-task" style={{ fontSize: '2em' }}></i>
              </h1>
              <h3>
                Écouter les tâches
              </h3>
            </Card.Body>
          </Card>
          <Card className="mb-3" style={{ borderRadius: '20px'}} onClick={aksQuestion}>
            <Card.Body style={{ backgroundColor: '#FF00FF', color: 'white', borderRadius: '20px' }}>
              <h1>
                <i className="bi bi-patch-question-fill" style={{ fontSize: '2em' }}></i>
              </h1>
              <h3>
                Poser une question
              </h3>
            </Card.Body>
          </Card>
          <Card className="mb-3" style={{ borderRadius: '20px'}} onClick={backHome}>
            <Card.Body style={{ backgroundColor: '#7C0A02', color: 'white', borderRadius: '20px' }}>
              <h1>
                <i className="bi bi-house-fill" style={{ fontSize: '2em' }}></i>
              </h1>
              <h3>
                Revenir à l'accueil
              </h3>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default OcrNext
